import React from 'react';
import { useTranslation } from 'react-i18next';
import FAQPage from './FAQPage';
import FAQPageEs from './FAQPage_es';

const FAQPageWrapper: React.FC = () => {
    const { i18n } = useTranslation();

    if (i18n.language === 'es') {
        return <FAQPageEs />;
    }

    return <FAQPage />;
};

export default FAQPageWrapper;
